import type Feature from 'ol/Feature'
import type Geometry from 'ol/geom/Geometry'
import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { setLayerMetadata } from '../../layerMetadata'

import { createRoadSegmentFeature } from './createRoadSegmentFeature'
import { findRoadSegmentMarker } from './findRoadSegmentMarker'

const nonblockingRender = createNonBlockingRenderByTime()

/**
 * Add new Features for all the RoadSegment marked for creation in a Changelog coming form the data-layer
 */
export async function changelogAddRoadSegmentFeatures(
  layer: VectorLayer<VectorSource>,
  roadSegments: uui.domain.ui.map.markers.MapMarkers['roadSegment'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['roadSegment'],
  selection: Set<string>,
  roadSegmentIds: IterableIterator<string>,
) {
  const features: Feature<Geometry>[] = []

  nonblockingRender.reset()

  for (const roadSegmentId of roadSegmentIds) {
    await nonblockingRender.next()
    const marker = findRoadSegmentMarker(roadSegments, roadSegmentId)
    const selected = selection.has(roadSegmentId)

    features.push(createRoadSegmentFeature(marker, mapStyles, selected))
  }

  // add all new features to the layer
  layer.getSource()?.addFeatures(features)

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
